export const filmInfo = {
  title: "岳母的诱惑",
  subtitle: "一场关于边界、克制与家庭信任的伦理叙事",
  year: "2024",
  region: "中国大陆",
  genre: "家庭伦理 / 心理剧情",
  duration: "108 分钟",
  rating: "8.6",
  ratingCount: "2.4 万人评价",
  ageTip: "建议 18 岁以上观众观看",
  tags: ["家庭伦理", "心理剧情", "关系边界", "现实题材"],
  logline:
    "当一位母亲、一个女婿与一个忙于事业的女儿同住一个屋檐下，日常里那些说不出口的情绪，慢慢堆积成一场谁都不愿直面的家庭风暴。",
  heroImage:
    "https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20background%20with%20deep%20crimson%20and%20golden%20amber%20light%20gradients%2C%20soft%20film%20grain%20texture%2C%20moody%20dramatic%20atmosphere%2C%20blurred%20stage%20lighting%20shapes%2C%20elegant%20editorial%20poster%20aesthetic%2C%20no%20people%2C%20high%20detail&width=1600&height=900&seq=ym-hero-01&orientation=landscape",
  posterImage:
    "https://readdy.ai/api/search-image?query=Artistic%20minimalist%20movie%20poster%20design%20with%20deep%20wine%20red%20and%20warm%20gold%20color%20fields%2C%20abstract%20silhouette%20of%20an%20empty%20doorway%20and%20flowing%20curtain%2C%20film%20grain%2C%20dramatic%20chiaroscuro%20lighting%2C%20refined%20editorial%20layout%2C%20no%20text%2C%20moody%20atmosphere&width=900&height=1200&seq=ym-poster-01&orientation=portrait",
};

export const quickFacts = [
  {
    label: "影片类型",
    value: "家庭伦理 · 心理剧情",
    icon: "ri-film-line",
  },
  {
    label: "片长",
    value: "108 分钟（正片）",
    icon: "ri-time-line",
  },
  {
    label: "上映年份",
    value: "2024 年",
    icon: "ri-calendar-line",
  },
  {
    label: "综合评分",
    value: "8.6 / 10",
    icon: "ri-star-line",
  },
  {
    label: "画质规格",
    value: "1080P / 4K 可选",
    icon: "ri-hd-line",
  },
  {
    label: "语言字幕",
    value: "普通话 · 中英字幕",
    icon: "ri-translate-2",
  },
];

export const synopsis = {
  paragraphs: [
    "《岳母的诱惑》把镜头对准了一个再普通不过的三口之家：建筑设计师陈志远与妻子苏晴结婚六年，因为工作和房贷的考量，搬回了苏晴母亲林淑华的老房子同住。退休教师林淑华做事有条理、待人有分寸，是她所在社区里公认的体面人。三个成年人分享同一间厨房、同一段走廊、同一份被生活磨得所剩无几的耐心。",
    "影片并不急着抛出冲突。它先是耐心铺陈那些琐碎的日常——谁先回家、谁多买了一份菜、谁在深夜还亮着灯。正是这些看似无害的细节，一点点暴露出三个人之间从未被认真谈过的期待与失望。当陈志远开始把心事说给岳母听，当苏晴意识到自己成了家里的“局外人”，一段原本稳固的关系开始出现细小的裂痕。",
    "导演选择用克制的镜头语言处理这些情绪：大量固定机位、长焦压缩的空间、几乎不留配乐的静场。观众看到的是三个人在同一张餐桌旁各怀心事，却谁都不愿先开口。片名里的“诱惑”并非指向身体，而是指向一种更隐蔽的吸引——被理解、被需要、被看见的渴望。",
    "到了第三幕，一场原本平常的家庭晚餐成为所有积压情绪的出口。影片没有给任何人下判决，也没有廉价的道德说教，而是把问题重新交还给观众：在亲密的家庭关系里，边界究竟应该画在哪里？",
  ],
  image:
    "https://readdy.ai/api/search-image?query=Warm%20muted%20interior%20of%20an%20old%20Chinese%20family%20apartment%2C%20wooden%20dining%20table%20with%20three%20empty%20chairs%2C%20afternoon%20light%20through%20sheer%20curtains%2C%20dust%20in%20the%20air%2C%20cinematic%20film%20still%2C%20soft%20melancholy%20tone%2C%20no%20people%2C%20high%20detail&width=1200&height=900&seq=ym-synopsis-01&orientation=landscape",
  highlights: [
    { value: "108", unit: "分钟", text: "一镜看完的长片叙事" },
    { value: "12", unit: "个场景", text: "几乎全在同一屋檐下展开" },
    { value: "3", unit: "位主角", text: "关系张力全部落在三人之间" },
  ],
};

export const themes = [
  {
    id: "boundary",
    icon: "ri-shield-keyhole-line",
    title: "边界与距离",
    summary:
      "同住一个屋檐，却更需要清晰的边界。影片反复追问：亲密关系里，什么该共享，什么应该保留。",
    detail:
      "从谁可以进谁的房间，到哪句话只是关心、哪句话已经越界，导演用大量生活细节把“边界”这个抽象概念具体化。林淑华习惯性地替小两口做决定，陈志远出于礼貌从不拒绝，苏晴则把这些都当成理所当然——直到某天，她发现自己在家里反而最像一个客人。",
  },
  {
    id: "desire",
    icon: "ri-heart-3-line",
    title: "渴望与克制",
    summary:
      "片名里的“诱惑”更接近一种被理解的渴望。人物最动人的时刻，往往出现在他们克制住的那一刻。",
    detail:
      "影片最高明的地方，是把所有可能滑向戏剧化的冲动都按下去。一个眼神、一次欲言又止的停顿、一杯放在桌上却没被喝掉的茶，构成了整部电影最紧绷的部分。克制不是没有欲望，而是欲望被责任与体面层层包裹。",
  },
  {
    id: "trust",
    icon: "ri-links-line",
    title: "信任的裂缝",
    summary:
      "婚姻里最危险的从来不是第三个人，而是两个人之间逐渐消失的对话。",
    detail:
      "苏晴与陈志远的问题并不来自外部，而是他们早已习惯了“替对方着想”式的沉默。当两个人都不愿意表达真实需求，家里的第三个人就自然成了情绪的出口。影片用这个结构提醒观众：关系需要被持续维护，而不是靠惯性维持。",
  },
  {
    id: "grey",
    icon: "ri-contrast-drop-line",
    title: "伦理的灰色地带",
    summary:
      "影片没有反派，每个人都在自认为正确的立场上做出选择，也因此没有人真的无辜。",
    detail:
      "林淑华的体面、陈志远的体贴、苏晴的拼搏，单独拿出来都无可指摘，放在一起却彼此消耗。导演刻意不给观众一个可以简单指认的“坏人”，让道德判断变得困难，也正因为困难，故事才更接近真实生活。",
  },
  {
    id: "silence",
    icon: "ri-chat-off-line",
    title: "沟通的失效",
    summary:
      "所有矛盾都始于“说了也没用”。当沟通被放弃，误解就会自动补位。",
    detail:
      "全片有大量“未完成的对话”：门被关上、话被打断、话题被岔开。这些留白并非节奏问题，而是影片的核心表达——很多家庭的破裂，并不是因为激烈的争吵，而是因为再也没有人愿意认真听完对方说完一句话。",
  },
  {
    id: "space",
    icon: "ri-home-4-line",
    title: "空间即关系",
    summary:
      "老房子的走廊、厨房与阳台，都是人物关系的具象化表达。",
    detail:
      "美术与摄影把有限的空间用到了极致：狭窄的走廊制造压迫感，敞开的厨房代表无处可藏，而唯一的阳台则是全片唯一能“喘口气”的地方。观众会发现，当角色走进不同空间，他们的姿态与语气也随之改变。",
  },
];

export const characters = [
  {
    name: "林淑华",
    role: "岳母 · 退休教师",
    age: "52 岁",
    desc: "做事有条理、在意体面，把“为你好”当成表达关心的方式。她并不觉得自己越界，只是觉得这个家需要有人撑着。",
    actor: "饰：周云岚",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20an%20elegant%20mature%20East%20Asian%20woman%20in%20her%20fifties%2C%20refined%20grey%20blazer%2C%20calm%20composed%20expression%2C%20warm%20dim%20interior%20lighting%2C%20soft%20shadow%2C%20drama%20film%20still%20mood%2C%20simple%20muted%20background&width=800&height=800&seq=ym-char-01&orientation=squarish",
  },
  {
    name: "陈志远",
    role: "女婿 · 建筑设计师",
    age: "35 岁",
    desc: "理性、克制、习惯把情绪向内收。他以为“不添麻烦”就是体贴，却不知道沉默本身也是一种表态。",
    actor: "饰：顾承宇",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20thoughtful%20East%20Asian%20man%20in%20his%20mid%20thirties%2C%20simple%20knit%20sweater%2C%20reserved%20expression%2C%20warm%20side%20lighting%2C%20drama%20film%20still%2C%20simple%20muted%20background&width=800&height=800&seq=ym-char-02&orientation=squarish",
  },
  {
    name: "苏晴",
    role: "女儿 · 职场女性",
    age: "31 岁",
    desc: "事业心强、目标明确，习惯用忙碌解决问题。她最害怕的不是失去，而是发现自己一直是最后一个知情的人。",
    actor: "饰：沈知微",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20modern%20East%20Asian%20woman%20in%20her%20early%20thirties%2C%20neat%20professional%20attire%2C%20focused%20confident%20look%2C%20warm%20soft%20lighting%2C%20drama%20film%20still%2C%20simple%20muted%20background&width=800&height=800&seq=ym-char-03&orientation=squarish",
  },
  {
    name: "老周",
    role: "邻居 · 退休医生",
    age: "60 岁",
    desc: "楼上住了三十年的老邻居，不多话，却总在关键时刻递出一句寻常的提醒。他是这个家庭唯一的旁观者。",
    actor: "饰：贺文山",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20an%20elderly%20East%20Asian%20man%20in%20his%20sixties%2C%20wearing%20glasses%20and%20a%20cardigan%2C%20gentle%20observant%20expression%2C%20warm%20interior%20light%2C%20drama%20film%20still%2C%20simple%20muted%20background&width=800&height=800&seq=ym-char-04&orientation=squarish",
  },
];

export const castList = [
  { role: "林淑华", actor: "周云岚", note: "三届话剧最佳女主角，擅长诠释内敛而复杂的母亲形象。" },
  { role: "陈志远", actor: "顾承宇", note: "出道十余年，以克制、细腻的表演风格著称。" },
  { role: "苏晴", actor: "沈知微", note: "新生代实力演员，凭本片提名年度最佳女主角。" },
  { role: "老周", actor: "贺文山", note: "资深舞台剧演员，本片为其近年少有的电影作品。" },
  { role: "导演 / 编剧", actor: "陆青原", note: "长期关注家庭题材，作品以冷静克制的纪实风格见长。" },
  { role: "摄影指导", actor: "谈亦舟", note: "偏好自然光与固定机位，为本片设计了大量长镜头。" },
  { role: "剪辑 / 配乐", actor: "苏和声", note: "坚持“留白即表达”，全片配乐时长不足十分钟。" },
];

export const stills = [
  {
    caption: "第一幕 · 家宴",
    text: "三个人围坐一桌，菜是热的，话是冷的。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20warm%20dim%20family%20dining%20room%20with%20a%20set%20table%20and%20steaming%20dishes%2C%20empty%20chairs%2C%20golden%20evening%20light%2C%20melancholy%20mood%2C%20no%20people%2C%20high%20detail&width=1200&height=800&seq=ym-still-01&orientation=landscape",
  },
  {
    caption: "第二幕 · 走廊",
    text: "狭窄的老房子走廊，是整部电影最常出现也最压抑的空间。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20narrow%20old%20apartment%20hallway%20at%20dusk%2C%20warm%20amber%20light%20from%20a%20single%20lamp%2C%20long%20shadows%2C%20quiet%20tense%20atmosphere%2C%20no%20people%2C%20high%20detail&width=1200&height=800&seq=ym-still-02&orientation=landscape",
  },
  {
    caption: "第三幕 · 雨夜",
    text: "窗外下着雨，屋里的人终于愿意把话说完。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20rain%20streaking%20down%20a%20large%20window%20at%20night%2C%20warm%20interior%20glow%20reflected%20on%20the%20glass%2C%20bokeh%20city%20lights%2C%20melancholy%20cinematic%20mood%2C%20no%20people%2C%20high%20detail&width=1200&height=800&seq=ym-still-03&orientation=landscape",
  },
  {
    caption: "尾声 · 阳台",
    text: "全片唯一能让人喘口气的地方，也是故事重新开始的地方。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20small%20apartment%20balcony%20at%20early%20morning%2C%20potted%20plants%2C%20soft%20golden%20sunrise%20light%2C%20quiet%20hopeful%20mood%2C%20no%20people%2C%20high%20detail&width=1200&height=800&seq=ym-still-04&orientation=landscape",
  },
];

export const reviews = [
  {
    name: "深夜观影人",
    tag: "长评 · 已看完",
    rating: 5,
    text: "以为是那种靠噱头撑场面的片子，结果一路看下来特别安静，安静到有点难受。第三幕那顿饭，我几乎屏住了呼吸。导演没有替观众做判断，这点很高级。",
  },
  {
    name: "柯南不推理",
    tag: "短评",
    rating: 5,
    text: "冲着片名来的，看完反而在想自己家里的事。所谓“诱惑”，其实是被理解的那种渴望吧。演员的克制演得真好。",
  },
  {
    name: "阿莫的电影本",
    tag: "影评人 · 长评",
    rating: 4,
    text: "摄影和美术是加分项，固定机位加长焦把空间的压迫感做足了。缺点是中段节奏偏慢，但如果耐心看完，最后三十分钟值得。",
  },
  {
    name: "住在楼道口的猫",
    tag: "短评",
    rating: 5,
    text: "全片配乐不到十分钟，却一点不觉得闷。走廊那几场戏，灯亮着反而更冷。推荐给喜欢现实题材的人。",
  },
  {
    name: "周末不出门",
    tag: "短评",
    rating: 4,
    text: "没有反转，没有狗血，就是三个成年人在一间屋子里互相消耗。看完有点后劲，第二天还在想结局那扇窗。",
  },
  {
    name: "胶片收藏家",
    tag: "长评",
    rating: 5,
    text: "很喜欢它不给人物贴标签的处理。林淑华不是恶人，苏晴也不是受害者，陈志远更谈不上背叛。正因为谁都没错，才显得谁都逃不掉。",
  },
];

export const watchSteps = [
  {
    step: "01",
    icon: "ri-search-eye-line",
    title: "确认片源信息",
    text: "先核对片名、年份与片长，确保是 108 分钟的完整正片，而非片段剪辑或花絮合集。",
  },
  {
    step: "02",
    icon: "ri-settings-3-line",
    title: "选择画质规格",
    text: "根据网络情况选择 720P、1080P 或 4K。本片以暗调与自然光为主，建议至少选择 1080P 以保留画面细节。",
  },
  {
    step: "03",
    icon: "ri-headphone-line",
    title: "调好声音环境",
    text: "影片配乐极少，大量情绪藏在环境音与对白停顿里。建议佩戴耳机或使用稳定音响，避免错过细节。",
  },
  {
    step: "04",
    icon: "ri-translate-2",
    title: "打开中文字幕",
    text: "对白语速平缓但信息量大，开启中文字幕更易跟上人物之间的潜台词与语气变化。",
  },
  {
    step: "05",
    icon: "ri-moon-clear-line",
    title: "建议一次看完",
    text: "影片节奏前松后紧，分次观看容易削弱第三幕的情绪累积，建议预留完整的两小时一口气看完。",
  },
];

export const faqs = [
  {
    q: "《岳母的诱惑》讲的是一个什么样的故事？",
    a: "它是一部家庭伦理题材的心理剧情片，讲述女婿、女儿与岳母三人在同一屋檐下生活时，因边界模糊与沟通失效而逐渐产生的家庭张力。影片关注的是关系本身，而非猎奇情节。",
  },
  {
    q: "影片的片长和画质规格是怎样的？",
    a: "正片时长约 108 分钟，提供 720P、1080P 与 4K 多种清晰度。由于影片以暗调、自然光镜头为主，建议至少选择 1080P 观看，以保留画面中的光影层次与细节。",
  },
  {
    q: "适合和家人一起观看吗？",
    a: "影片整体以克制、写实的方式呈现家庭关系，没有过度渲染的情节，但因涉及成年人的情感与伦理议题，更建议成年观众单独观看，或在观影后就片中话题进行讨论。",
  },
  {
    q: "这部片子节奏慢吗？会不会看不下去？",
    a: "影片前半段节奏较缓，重在铺陈日常细节与人物关系；后半段情绪集中释放。如果你偏好快节奏强情节，可以先了解剧情简介再决定是否观看。",
  },
  {
    q: "影片有续集或衍生作品吗？",
    a: "目前公开信息中，本片为独立成篇的单部作品，没有官方确认的续集或衍生内容。遇到以“第二部”“前传”为名的资源，建议谨慎核对来源。",
  },
  {
    q: "为什么片名里有“诱惑”二字？",
    a: "片名中的“诱惑”更多是一种隐喻，指向人物对被理解、被需要、被看见的深层渴望，而不是字面意义上的情色指向。这也是影片在叙事上刻意保持克制的重要原因。",
  },
];

export const relatedFilms = [
  {
    title: "沉默的家宴",
    meta: "2023 · 家庭剧情 · 96 分钟",
    desc: "一次久别重逢的团圆饭，把三代人积压二十年的心结重新摆上桌面。",
    image:
      "https://readdy.ai/api/search-image?query=Minimalist%20movie%20poster%20art%20with%20warm%20amber%20and%20deep%20brown%20tones%2C%20abstract%20empty%20dining%20table%20silhouette%2C%20film%20grain%20texture%2C%20moody%20editorial%20design%2C%20no%20text&width=600&height=900&seq=ym-rel-01&orientation=portrait",
  },
  {
    title: "雨夜访客",
    meta: "2022 · 心理悬疑 · 112 分钟",
    desc: "一个雨夜，一位不速之客的到访，让一个平静家庭隐藏的秘密逐渐浮出水面。",
    image:
      "https://readdy.ai/api/search-image?query=Minimalist%20movie%20poster%20art%20with%20cool%20charcoal%20and%20faint%20amber%20tones%2C%20abstract%20rain%20window%20silhouette%2C%20film%20grain%20texture%2C%20moody%20editorial%20design%2C%20no%20text&width=600&height=900&seq=ym-rel-02&orientation=portrait",
  },
  {
    title: "边界",
    meta: "2024 · 现实题材 · 104 分钟",
    desc: "三个合租的陌生人在同一屋檐下，重新学习如何相处，也重新定义彼此的距离。",
    image:
      "https://readdy.ai/api/search-image?query=Minimalist%20movie%20poster%20art%20with%20sage%20green%20and%20warm%20grey%20tones%2C%20abstract%20doorway%20and%20light%20silhouette%2C%20film%20grain%20texture%2C%20moody%20editorial%20design%2C%20no%20text&width=600&height=900&seq=ym-rel-03&orientation=portrait",
  },
  {
    title: "旧信封",
    meta: "2021 · 文艺剧情 · 118 分钟",
    desc: "一封从未寄出的信，串起一对母女跨越三十年的误解与和解。",
    image:
      "https://readdy.ai/api/search-image?query=Minimalist%20movie%20poster%20art%20with%20dusty%20rose%20and%20cream%20tones%2C%20abstract%20folded%20letter%20silhouette%2C%20film%20grain%20texture%2C%20moody%20editorial%20design%2C%20no%20text&width=600&height=900&seq=ym-rel-04&orientation=portrait",
  },
  {
    title: "长夜将尽",
    meta: "2020 · 家庭伦理 · 100 分钟",
    desc: "一个普通家庭在一个失眠的长夜里，把多年不敢说的话一次性说了出来。",
    image:
      "https://readdy.ai/api/search-image?query=Minimalist%20movie%20poster%20art%20with%20deep%20wine%20red%20and%20midnight%20tones%2C%20abstract%20window%20and%20moonlight%20silhouette%2C%20film%20grain%20texture%2C%20moody%20editorial%20design%2C%20no%20text&width=600&height=900&seq=ym-rel-05&orientation=portrait",
  },
];

export const navLinks = [
  { id: "synopsis", label: "影片简介" },
  { id: "themes", label: "主题看点" },
  { id: "characters", label: "角色图鉴" },
  { id: "cast", label: "主创阵容" },
  { id: "stills", label: "画面预览" },
  { id: "reviews", label: "观众评价" },
  { id: "guide", label: "观影指南" },
  { id: "faq", label: "常见问题" },
];